export default __webpack_public_path__ + "static/media/import.f9ec9b39.svg";